module.exports = __webpack_public_path__ + "static/media/backdoor_VP8.e2a39707.gif";